<template>
  <v-content>
    <Header></Header>

    <v-layout
      justify-center
      align-center
      style="position: relative;height: 60%"
      :style="{
        background: `url(${require('../assets/portfolio-bg.png')}) no-repeat`,
        'background-size': 'cover',
      }"
    >
      <div class="gray-layer"></div>
      <v-flex xs11 sm10 md6>
        <v-card elevation="8" class="overflow-hidden">
          <v-layout>
            <v-flex py-12 px-5 px-md-10>
              <v-layout class="justify-center mb-6">
                <v-flex class="shrink">
                  <img :src="require('../assets/tcdc-color.png')" />
                </v-flex>
              </v-layout>

              <v-layout v-if="check_verify === true">
                <v-flex class="text-center">
                  <div>
                    <span>ยืนยันตัวตนสำเร็จ</span>
                  </div>
                  <div class="mt-6">
                    <v-btn
                      color="#FD5246"
                      dark
                      small
                      @click="$router.push('/login')"
                    >
                      <span>เข้าสู่ระบบ</span>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout v-else>
                <v-flex class="text-center">
                  <span>ยืนยันตัวตนไม่สำเร็จ</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <Footer class=""></Footer>

    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  name: "Verify",
  components: {
    Loading,
    Header,
    Footer,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    check_verify: "",
  }),
  created() {
    this.checkVerifyEmail();
  },
  methods: {
    checkVerifyEmail() {
      this.isLoading = true;
      this.$store
        .dispatch("auth/checkVerifyEmail", this.$route.query.token)
        .then((res) => {
          this.isLoading = false;
          this.check_verify = true;
        })
        .catch((e) => {
          this.isLoading = false;
          this.check_verify = false;
        });
    },
  },
};
</script>

<style scoped>
.gray-layer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
}
</style>
